module.exports = __webpack_public_path__ + "static/media/3.2f40b6cc.JPG";